import AppSvgIcon from "./AppSvgIcon";

export default AppSvgIcon;
